module.exports = __webpack_public_path__ + "static/media/logAnalyzerIcon.281a164f.svg";